/* eslint-disable max-len */
import { EDGE_COLORS } from '../../modules/fences/components/PuzzleFencesModel';

const DIRECTIONS = [
  {
    id: 'top', dx1: 0, dy1: 0, dx2: 1, dy2: 0,
  },
  {
    id: 'right', dx1: 1, dy1: 0, dx2: 1, dy2: 1,
  },
  {
    id: 'bottom', dx1: 0, dy1: 1, dx2: 1, dy2: 1,
  },
  {
    id: 'left', dx1: 0, dy1: 0, dx2: 0, dy2: 1,
  },
];

export default function generateFencesSVG(table, rows, cols, options = {}) {
  const config = {
    cellSize: 60,
    padding: 30,
    dotRadius: 4.8,
    fontSize: 20,
    pathWeight: 'normal',
    transparentBackground: false,
    showAnswer: false,
    gridColor: '#000000',
    dotColor: '#555555',
    ...options,
  };

  const weights = {
    thin: 1.5,
    normal: 3.5,
    bold: 5,
  };
  const strokeWidth = weights[config.pathWeight] || 3.5;

  const borderOffset = 16;
  const borderStrokeWidth = 4;

  const gridWidth = cols * config.cellSize;
  const gridHeight = rows * config.cellSize;
  const svgWidth = gridWidth + config.padding * 2;
  const svgHeight = gridHeight + config.padding * 2;

  const bg = config.transparentBackground ? 'none' : '#ffffff';

  let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
  <g transform="translate(${config.padding}, ${config.padding})">
    
    <rect x="${-borderOffset}" y="${-borderOffset}" 
          width="${gridWidth + (borderOffset * 2)}" height="${gridHeight + (borderOffset * 2)}"
          fill="${bg}" stroke="${config.gridColor}" stroke-width="${borderStrokeWidth}" />`;

  table.forEach(cell => {
    const x = cell.positionx * config.cellSize;
    const y = cell.positiony * config.cellSize;

    DIRECTIONS.forEach(direction => {
      const x1 = x + direction.dx1 * config.cellSize;
      const y1 = y + direction.dy1 * config.cellSize;
      const x2 = x + direction.dx2 * config.cellSize;
      const y2 = y + direction.dy2 * config.cellSize;

      let color = null;

      if (config.showAnswer && cell.edges && cell.edges[direction.id]) {
        color = config.colored ? EDGE_COLORS.path : '#000000';
      }

      if ((cell.fixedEdges && cell.fixedEdges[direction.id]) || (cell.extraEdges && cell.extraEdges[direction.id])) {
        color = config.colored ? EDGE_COLORS.fixed : '#000000';
      }

      if (color) {
        svg += `\n    <line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
        stroke = "${color}" stroke-width="${strokeWidth}" stroke-linecap="butt"/>`;
      }
    });
  });

  table.forEach(cell => {
    if (cell.value !== null && cell.value !== undefined) {
      const x = cell.positionx * config.cellSize + config.cellSize / 2;
      const y = cell.positiony * config.cellSize + config.cellSize / 2;
      svg += `\n    <text x="${x}" y="${y}" font-family="Arial" font-size="${config.fontSize}"
      text-anchor="middle" dominant-baseline="central" fill="#000000" font-weight="bold">${cell.value}</text>`;
    }
  });

  for (let r = 0; r <= rows; r += 1) {
    for (let c = 0; c <= cols; c += 1) {
      svg += `\n <circle cx="${c * config.cellSize}" cy="${r * config.cellSize}"
      r="${config.dotRadius}" fill="${config.dotColor}" />`;
    }
  }

  svg += '\n  </g>\n</svg>';
  return svg;
}
